import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  PUBLIC_HOLIDAY_DETAIL_TYPE,
  PUBLIC_HOLIDAY_LIST_PARAMS_REQUEST,
  PUBLIC_HOLIDAY_LIST_STATE,
} from 'models/public-holiday';

export interface PublicHolidayState {
  publicHoliday: {
    list: PUBLIC_HOLIDAY_LIST_STATE;
    detail: PUBLIC_HOLIDAY_DETAIL_TYPE | null;
  };
}

const initialState: PublicHolidayState = {
  publicHoliday: {
    list: {
      records: [],
      metadata: {
        page: 1,
        limit: 50,
        page_count: 1,
        total_pages: 1,
        total_count: 1,
      },
      params: {
        page: 1,
        limit: 50,
      },
    },
    detail: null,
  },
};

const publicHolidaySlice = createSlice({
  name: 'publicHoliday',
  initialState,
  reducers: {
    setPublicHolidayListSuccess(
      state: PublicHolidayState,
      action: PayloadAction<PUBLIC_HOLIDAY_LIST_STATE>
    ) {
      state.publicHoliday.list = {
        ...state.publicHoliday.list,
        ...action.payload,
      };
    },
    setPublicHolidayListParams(
      state: PublicHolidayState,
      action: PayloadAction<PUBLIC_HOLIDAY_LIST_PARAMS_REQUEST | null>
    ) {
      state.publicHoliday.list.params = action.payload;
    },
    setPublicHolidayDetail(
      state: PublicHolidayState,
      action: PayloadAction<PUBLIC_HOLIDAY_DETAIL_TYPE | null>
    ) {
      state.publicHoliday.detail = action.payload;
    },
  },
});

// Actions
export const {
  setPublicHolidayListSuccess,
  setPublicHolidayListParams,
  setPublicHolidayDetail,
} = publicHolidaySlice.actions;

export default publicHolidaySlice.reducer;
